import {
  DocumentTextIcon,
  GiftIcon,
  InformationCircleIcon,
  PhoneIncomingIcon,
  ShieldCheckIcon,
  ShieldExclamationIcon,
  ShoppingBagIcon,
  UserGroupIcon,
} from "@heroicons/react/outline";

export const ResourcesData = [
  {
    name: "Offer",
    href: "offer",
    icon: GiftIcon,
  },
  {
    name: "Checkout",
    href: "checkout",
    icon: ShoppingBagIcon,
  },
  {
    name: "FAQ",
    href: "faq",
    icon: ShieldExclamationIcon,
  },
  {
    name: "About Us",
    href: "about-us",
    icon: UserGroupIcon,
  },
  {
    name: "Contact Us",
    href: "contact-us",
    icon: PhoneIncomingIcon,
  },
  {
    name: "Privacy Policy",
    href: "privacy-policy",
    icon: ShieldCheckIcon,
  },
  {
    name: "Terms & Conditions",
    href: "terms-and-conditions",
    icon: DocumentTextIcon,
  },
  {
    name: "404",
    href: "404",
    icon: InformationCircleIcon,
  },
];